// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pIFD","questions":"styles_questions__3MalT","footer":"styles_footer__NO5Ip"};